import { Injectable } from "@angular/core";
import { App, AppState } from "@capacitor/app";
import { Platform } from "@ionic/angular";
import { BehaviorSubject, distinctUntilChanged, Observable } from "rxjs";

@Injectable({
	providedIn: 'root',
})
export class AppStateService {
	private _isInForeground = new BehaviorSubject<boolean>(true);

	get isInForeground$(): Observable<boolean> {
		return this._isInForeground.asObservable().pipe(distinctUntilChanged());
	}

	constructor(
		private platform: Platform,
	) {
		this.initAppStateListener();
	}

	private async initAppStateListener() {
		try {
			await this.platform.ready();
			await App.addListener('appStateChange', (state: AppState) => {
                this._isInForeground.next(state.isActive);
            });
		} catch (error) {
			console.error('[AppStateService] - initAppStateListener error: ', error);
		}
    }
}
